/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MicrosoftSignupConfig
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Whether to use the Microsoft sign-up flow, and with which client id.
 * @summary Microsoft Signup Config
 */
export const microsoftSignupConfig = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MicrosoftSignupConfig>(
      {url: `/auth/microsoft-signup/config`, method: 'GET', signal
    },
      options);
    }




export const getMicrosoftSignupConfigQueryKey = () => {
    return [
    `/auth/microsoft-signup/config`
    ] as const;
    }


export const getMicrosoftSignupConfigQueryOptions = <TData = Awaited<ReturnType<typeof microsoftSignupConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof microsoftSignupConfig>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMicrosoftSignupConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof microsoftSignupConfig>>> = ({ signal }) => microsoftSignupConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof microsoftSignupConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type MicrosoftSignupConfigQueryResult = NonNullable<Awaited<ReturnType<typeof microsoftSignupConfig>>>
export type MicrosoftSignupConfigQueryError = unknown


/**
 * @summary Microsoft Signup Config
 */

export function useMicrosoftSignupConfig<TData = Awaited<ReturnType<typeof microsoftSignupConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof microsoftSignupConfig>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMicrosoftSignupConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






